module.exports = __webpack_public_path__ + "media/images/vanguard-assessments-logo-d0c9c7d5a058cbb227d3b90de264d338.webp";